import { GridColDef } from '@mui/x-data-grid-pro'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import ChipsCell from '@/shared/components/Table/components/ChipsCell/ChipsCell'
import IconButton from '@/shared/components/IconButton/IconButton'
import styles from '../../MenuMangementColumns.module.scss'

export function useToppingsColumnsConfig(
  handleOnChange: (id: string) => void,
  handleOnDelete: (id: string) => void
) {
  const { t } = useTranslation()

  const columns = useMemo<GridColDef[]>(
    () => [
      {
      field: 'id',
      headerName: 'ID',
      resizable: false,
      width: 44,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      sortable: false,
      hideSortIcons: true,
      disableColumnMenu: true,
      hideable: false,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
      {
      field: 'name',
      headerName: t('TABLE.MENU.HEADERS.NAME'),
      flex: 1,
      editable: false,
      hideable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 80,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
      {
      field: 'description',
      headerName: t('TABLE.MENU.HEADERS.DESCRIPTION'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 128,

      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
      {
      field: 'price',
      headerName: t('TABLE.MENU.HEADERS.PRICE'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 80,

      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
      {
      field: 'categories',
      headerName: t('TABLE.MENU.HEADERS.DISH_CATEGORIES'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 128,

      sortable: false,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      ),
      renderCell: params => <ChipsCell chipPayload={params.value} />
    },
      {
      field: 'action',
      resizable: false,
      width: 80,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: `${styles.tableCell}`,
      disableColumnMenu: true,
      disableReorder: true,
      sortable: false,
      pinnable: true,
      minWidth: 80,
      maxWidth: 80,
      hideable: false,
      renderHeader: params => (
        <p
          className={`${styles.tableHeaderText} body-bold-medium hideRightSeparator`}
        >
          {params.colDef.headerName}
        </p>
      ),
      renderCell: params => (
        <div className={`${styles.tableActionContainer}`}>
          <IconButton
            icon="las la-edit icon-medium"
            onClick={() => handleOnChange(params.row.id)}
            color="primary"
          />
          <IconButton
            icon="las la-trash icon-medium"
            onClick={() => handleOnDelete(params.row.id)}
            color="primary"
          />
        </div>
      )
      }
    ],
    [handleOnChange, handleOnDelete, t]
  )
  return columns
}
